module.exports = __webpack_public_path__ + "img/howell_5.6577c890.jpeg";